<div
  *ngIf="showHeader()"
  class="flex flex-wrap justify-center h-[72px] bg-white py-3">
  <div class="flex w-10/12 h-full sm:w-11/12 mx-auto">
    <div class="flex flex-none h-full items-center w-2/12 py-1">
      <img
        [src]="resource.header.logo_h"
        alt="logo-app"
        class="h-full" />
    </div>
    <div
      *ngIf="showMenu()"
      class="shrink-0 h-full w-8/12">
      <div class="lg:flex hidden justify-center space-x-4">
        <button
          *ngIf="isButtonVisible(ACCUEIL)"
          pButton
          class="lg:table-cell rounded-md py-3 px-3 text-darkest"
          [routerLink]="[ACCUEIL]"
          routerLinkActive="bg-primary_text text-white font-app-regular text-[16px]">
          <i class="pi pi-home mr-3"></i>
          <span class="font-app-regular text-[16px]">{{ "header.home" | translate }}</span>
        </button>
        <button
          *ngIf="isButtonVisible(MON_PROFIL)"
          pButton
          class="lg:table-cell rounded-md py-3 px-3 text-darkest"
          [routerLink]="[MON_PROFIL]"
          routerLinkActive="bg-primary_text text-white font-app-regular text-[16px]"
          autoBlur="true">
          <i class="pi pi-user mr-3"></i>
          <span class="font-app-regular text-[16px]">{{ "header.profil" | translate }}</span>
        </button>
        <button
          *ngIf="isButtonVisible(NOS_OFFRES)"
          pButton
          class="md:table-cell rounded-md py-3 px-3 text-darkest"
          [routerLink]="[NOS_OFFRES]"
          routerLinkActive="bg-primary_text text-white font-app-regular text-[16px]"
          autoBlur="true">
          <i class="pi pi-file mr-3"></i>
          <span class="font-app-regular text-[16px]">{{ "header.offers" | translate }}</span>
        </button>
        <button
          *ngIf="isButtonVisible(NOUS_CONTACTER)"
          pButton
          class="lg:table-cell rounded-md py-3 px-3 text-darkest"
          [routerLink]="[NOUS_CONTACTER]"
          routerLinkActive="bg-primary_text text-white font-app-regular text-[16px]"
          autoBlur="true">
          <i class="pi pi-phone mr-3"></i>
          <span class="font-app-regular text-[16px]">{{ "header.contact" | translate }}</span>
        </button>
      </div>
    </div>
    <div
      *ngIf="showMenu()"
      class="flex flex-none h-full justify-end w-2/12 md:py-3 py-4">
      <app-logout *ngIf="isButtonVisible('DECONNEXION')"
        class="lg:flex hidden items-center"
        (menuOpenEmitter)="menuOpen($event)"></app-logout>
      <app-header-mobile
        class="lg:hidden flex"
        (menuOpenEmitter)="menuOpen($event)"></app-header-mobile>
    </div>
  </div>
</div>
<div
  class="bg-dark h-full w-full fixed top-0 left-0 opacity-50 z-10"
  [ngClass]="{ hidden: !isMenuOpen }"></div>
